import { useMemo } from "react";
import Svg, { Path } from "react-native-svg";
import { Platform, View } from "react-native";

import type { IconProps } from "./types";
export function Check({
  size = 24,
  color,
  style,
  ...props
}: Omit<IconProps, "width" | "height" | "viewBox" | "fill">) {
  const defaultColor = useMemo(
    () => (Platform.OS === "web" ? "currentcolor" : "black"),
    []
  );
  const component = (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color ? color : defaultColor}
      {...props}
    >
      <Path
        d="M8.754 19a.468.468 0 01-.334-.141l-6.277-6.406a.488.488 0 01-.127-.468.477.477 0 01.336-.343.466.466 0 01.459.13l5.943 6.065L21.181 5.154a.466.466 0 01.463-.14.477.477 0 01.341.35.489.489 0 01-.136.472L9.087 18.859a.464.464 0 01-.333.141z"
        fill={color ? color : defaultColor}
      />
    </Svg>
  );

  if (style) {
    return <View style={style}>{component}</View>;
  }

  return component;
}
